import { Component, VERSION } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { OnlineStatusService, OnlineStatusType } from 'ngx-online-status';
import { ConnectionService } from 'ng-connection-service'
import { WebsocketService } from './services/websocket.service';
import { NavigationStart, Router } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'assetManagementUI';

  isOnline: boolean = navigator.onLine;

  name = "Angular " + VERSION.major;

  deviceInfo: any;
  isDesktopDevice: boolean | undefined;
  isTablet: boolean | undefined;
  isMobile: boolean | undefined;
  OnlineStatusType = OnlineStatusType;

  status: any;
  isConnected: any = true;

  constructor(private router: Router,
    private websocket: WebsocketService, private translate: TranslateService,
    private deviceService: DeviceDetectorService, private onlineStatusService: OnlineStatusService, private connectionService: ConnectionService) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.status = isConnected.hasNetworkConnection;
      // if(this.status){
      //   window.location.reload();
      // }
    });

    // this.translate.addLangs(['en', 'fr']);
    const savedLang = localStorage.getItem('appLang') || 'en';
    translate.setDefaultLang(savedLang);
    translate.use(savedLang);
    this.updateDirection(savedLang);

    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      this.updateDirection(event.lang);
    });




  }

  ngAfterViewInit() {
    setTimeout(() => {
      $(document).on('hidden.bs.modal', '.modal', function () {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
      });
    });

    setTimeout(() => {
      $(document).on('hidden.modal', '.modal', function () {
        $('body').removeClass('modal-open');
        $('.modal-backdrop').remove();
      });
    });
  }

  ngOnInit(): void {
    this.epicFunction()
    this.websocket.socketConnection()



    // Attach the modal cleanup handler
    $('.modal').on('hidden.modal', function () {
      $('body').removeClass('modal-open');
      $('.modal-backdrop').remove();
    });
  }

  epicFunction() {
    this.deviceInfo = this.deviceService.getDeviceInfo();
    this.isMobile = this.deviceService.isMobile();
    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();
  }



  isDarkMode = true;

  onThemeToggle(isDark: boolean): void {
    this.isDarkMode = isDark;
    if (isDark) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }

  updateDirection(lang: string) {
    // const dir = lang === 'ar' ? 'rtl' : 'ltr';
    // document.documentElement.setAttribute('dir', dir);
  }
}

